import { createRootRoute, Outlet } from '@tanstack/react-router';
import { Coquille } from '../coquille/Coquille';
import { Messages } from '../coquille/Messages';
import { Palette } from '../recherche/Palette';

/**
 * Dernier filet : une erreur de rendu ou de lecture d'URL que l'écran n'a pas rattrapée. Le lien recharge
 * la page à l'adresse de la carte, sans les paramètres qui ont pu la provoquer.
 */
function ErreurRacine() {
  return (
    <div role="alert" className="flex min-h-dvh flex-col items-start gap-3 bg-fond p-6 text-texte">
      <p className="font-medium">Cet écran n'a pas pu s'afficher.</p>
      <a
        href="/"
        className="cible flex items-center rounded-lg border border-bord bg-surface px-3 text-accent"
      >
        Revenir à la carte
      </a>
    </div>
  );
}

export const Route = createRootRoute({
  component: () => (
    <Coquille>
      <Outlet />
      <Palette bouton={false} />
      <Messages />
    </Coquille>
  ),
  notFoundComponent: () => <p className="p-6">Page introuvable.</p>,
  errorComponent: ErreurRacine,
});
